import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./LangToggle.scss";

const LangToggle = () => {    
    const [lang, setLang] = useState(localStorage.getItem('i18nextLng'));
    const { i18n } = useTranslation();

    if(lang === 'id'){ 
        import('moment/locale/id');
    }else{
        import('moment/locale/en-in');    
    }

    const setLanguage = (payload) => {
        window.location.reload();
        setLang(payload);
        i18n.changeLanguage(payload);
    }

    return (
        <div className="lang-toggle">
            <li>
                <button
                    className={`btn ${lang === 'id' ? 'selected' : ''}`}
                    onClick={() => setLanguage('id')}
                >
                    ID
                </button>
            </li>
            <li className="line"></li>
            <li>
                <button
                    className={`btn ${lang === 'en' ? 'selected' : ''}`}
                    onClick={() => setLanguage('en')}
                >
                    EN
                </button>
            </li>
        </div>
    );
}

export default LangToggle;